import informative from "@ingka/ssr-icon/paths/information-circle";
import cautionary from "@ingka/ssr-icon/paths/warning-triangle";
import positive from "@ingka/ssr-icon/paths/checkmark-circle";
import negative from "@ingka/ssr-icon/paths/cross-circle";
import { ReactNode } from "react";
import InlineMessage from "@ingka/inline-message";

type MessageProps = {
  children: ReactNode;
  variant?: "informative" | "positive" | "cautionary" | "negative";
  subtle?: boolean;
  role?: string;
  id?: string;
};

const Message = ({
  children,
  variant = "informative",
  subtle = false,
  role,
  id,
}: MessageProps) => {
  const iconMap = {
    cautionary,
    informative,
    positive,
    negative,
  };

  return (
    <InlineMessage
      role={role}
      id={id}
      body={<p>{children}</p>}
      variant={variant}
      ssrIcon={iconMap[variant]}
      subtle={subtle}
    />
  );
};

export default Message;
